// extracted by mini-css-extract-plugin
module.exports = {"checkList":"CheckList_checkList__27nV8","small":"CheckList_small__Vpg5g","icon":"CheckList_icon__oBmtB"};